var render, staticRenderFns
import script from "./SwipeImgAndVideo.vue?vue&type=script&lang=js&"
export * from "./SwipeImgAndVideo.vue?vue&type=script&lang=js&"
import style0 from "./SwipeImgAndVideo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports